import { DialogService } from "./../../../../../core/src/lib/services/dialog.service";
import { ReportService } from "./../../../../../../apps/resource-portal/src/app/services/report.service";
import { FolderExplorerComponent } from "./../folder-explorer/folder-explorer.component";
import { Component, Input, OnInit, ViewChild, ElementRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  EMPTY_GUID,
  CHANGE_TYPES,
} from "apps/resource-portal/src/app/constants/app.constant";
import { ApprovalService } from "apps/resource-portal/src/app/services/approval.service";
import { RoomService } from "apps/resource-portal/src/app/services/room.service";
import jsPDF from "jspdf";
import { CommonUtils } from "libs/core/src/lib/utils/common.utils";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "concourse-rxr-report",
  templateUrl: "./rxr-report.component.html",
  styleUrls: ["./rxr-report.component.scss"],
})
export class RxrReportComponent implements OnInit {
  projectId = null;
  departments = [];
  rooms = [];
  @Input() saveToFolder: boolean = false;
  @Input() selectedDepartment = null;
  @Input() selectedRoom = null;
  @Input() reportType = null;
  $unsubscribe = new Subject<void>();
  emptyGuid = EMPTY_GUID;
  changeTypes = CHANGE_TYPES;
  commonUtils = CommonUtils;
  activeIds = [];

  @ViewChild("content", { static: false }) el!: ElementRef;

  sortingOptions = [
    {
      display: "Name",
      value: "name",
    },
    {
      display: "Upload Date",
      value: "createdon",
    },
    {
      display: "Uploaded By",
      value: "createdby",
    },
  ];

  //new table
  reportItems = [];
  constructor(
    private activateRoute: ActivatedRoute,
    private _roomService: RoomService,
    private router: Router,
    private _approvalService: ApprovalService,
    public activeModal: NgbActiveModal,
    public _modalService: NgbModal,
    public _reportService: ReportService,
    private _dialogService: DialogService
  ) { }

  ngOnInit(): void {
    this.activateRoute.queryParams.subscribe((result) => {
      if (result && result["projectId"]) {
        this.projectId = result["projectId"];
        this.getAllDepartments(this.projectId);
      } else {
        this.router.navigate(["/projects"]);
      }
    });
  }

  getAllDepartments(projectId: string) {
    this._roomService
      .getDepartmentByProjectId(projectId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.departments = result || [];
          this.departments = CommonUtils.sortByKey(
            this.departments,
            "departmentname"
          );
          if (this.departments.length) {
            if (!this.selectedDepartment) {
              this.selectedDepartment = this.departments[0].id;
            }
            this.getAllRooms(this.selectedDepartment);
          } else {
            this.selectedDepartment = null;
          }
        }
      });
  }

  getAllRooms(departmentId: string) {
    this.selectedDepartment = departmentId;
    if (this.selectedDepartment == EMPTY_GUID) {
      this.selectedRoom = EMPTY_GUID;
      this.getRequests(this.selectedRoom);
    }
    this._roomService
      .getRoomsByDepartmentId(departmentId)
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result) {
          this.rooms = result || [];
          this.rooms = CommonUtils.sortByKey(this.rooms, "name");
          if (this.rooms.length) {
            if (!this.selectedRoom) {
              this.selectedRoom = EMPTY_GUID;
            }
            this.getRequests(this.selectedRoom);
          } else {
            this.selectedRoom = null;
          }
        }
      });
  }

  tableToExcel = (function () {
    // Define your style class template.
    var style = "<style>.green { background-color: green; }</style>";
    var uri = "data:application/vnd.ms-excel;base64,",
      template =
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]-->' +
        style +
        "</head><body><table>{table}</table></body></html>",
      base64 = function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format = function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      };
    return function (table, name) {
      table = document.getElementsByClassName("table-wrapper")[0];
      var ctx = { worksheet: name || "Worksheet", table: table.innerHTML };
      window.location.href = uri + base64(format(template, ctx));
    };
  })();

  getRequests(roomId: string) {
    this.selectedRoom = roomId;
    this.getApprovalRequests();
  }

  getApprovalRequests() {
    this._approvalService
      .getApprovalRequests(
        null,
        null,
        null,
        this.selectedDepartment,
        this.selectedRoom,
        null,
        this.projectId,
        null,
        true
      )
      .pipe(takeUntil(this.$unsubscribe))
      .subscribe((result) => {
        if (result && result.length) {
          if (result) {
            this.transformData(result);
          }
        } else {
          this.reportItems = [];
        }
      });
  }

  transformData(arr) {
    let datasource = arr.map((t) => {
      return {
        jsn: t?.jsn?.name,
        nomenclature: t?.jsn?.nomenclature,
        count: arr.filter((f) => f?.jsn?.name == t?.jsn?.name).length,
        data: this.groupByKey(arr)[t?.jsn?.name],
      };
    });
    this.reportItems = Array.from(new Set(datasource.map(JSON.stringify))).map(
      <any>JSON.parse
    );
    for (let i = 0; i < this.reportItems.length; i++) {
      this.activeIds.push("panel-" + i);
    }
  }
  groupByKey(datasource) {
    return datasource.reduce(function (a, c) {
      a[c.jsn.name] = a[c.jsn.name] || [];
      a[c.jsn.name].push(c);
      return a;
    }, Object.create(null));
  }

  makePdf() {
    let pdf = new jsPDF("p", "mm", "a4");
    pdf.html(this.el.nativeElement, {
      callback: (pdf) => {
        pdf.save("report-export.pdf");
      },
      html2canvas: {
        letterRendering: true,
        width: 1080,
        height: 1920,
        scale: 0.16,
      },
    });
  }

  openFolderExplorer() {
    const modalRef = this._modalService.open(FolderExplorerComponent, {
      centered: true,
      size: "xl",
      windowClass: "modal-class",
      backdrop: "static",
    });
    modalRef.componentInstance.projectId = this.projectId;
    let dept = this.departments.length
      ? this.departments.find((d) => d.id === this.selectedDepartment)
        .departmentname || ""
      : "";
    if (dept) {
      modalRef.componentInstance.reportName = this.reportType + " - " + dept;
    } else {
      modalRef.componentInstance.reportName = this.reportType;
    }
    modalRef.result.then((data: any) => {
      let pdf = new jsPDF("p", "mm", "a4");
      pdf.html(this.el.nativeElement, {
        callback: (pdf: any) => {
          let formData = new FormData();
          formData.append("folder", data.folderId);
          formData.append("reportname", data?.reportName || "");
          formData.append("project", this.projectId);
          formData.append("file", pdf.output("blob"));
          this._reportService
            .saveReportToFolder(formData)
            .pipe(takeUntil(this.$unsubscribe))
            .subscribe((result) => {
              if (result && result.status == 200) {
                this._dialogService.showToast(
                  "Report Uploaded to Folder",
                  "success"
                );
              }
            });
        },
        html2canvas: {
          letterRendering: true,
          width: 1080,
          height: 1920,
          scale: 0.16,
        },
      });
    });
  }

  ngOnDestroy() {
    this.$unsubscribe.next();
    this.$unsubscribe.complete();
  }
}
